import styled from 'styled-components';

import { PriceInput, PriceInputsWrapper } from '../price-filter/styles';

export const AreaInputsWrapper = styled(PriceInputsWrapper)``;

export const AreaInput = styled(PriceInput)``;
